module.exports = __webpack_public_path__ + "static/media/icon-report-print-arrow.6332e6bd.svg";